<template>
    <authenticated-layout>
        <v-card class="pa-6 mx-auto" max-width="600">
            <h1 class="py-2 mb-6 text-xl border-b">
                {{ $t("roofSheathingsPanel.Roof sheathings panel") }}
            </h1>

            <form @submit.prevent="onUpdate">
                <div
                    v-for="(item, index) in roofSheathingsData"
                    :key="item.id"
                    class="py-2 border-b-2 border-gray-200"
                >
                    <div
                        class="d-flex justify-space-between align-center mt-2 mb-4"
                    >
                        <h3>{{ item.name }}</h3>

                        <v-btn
                            color="error"
                            variant="flat"
                            size="x-small"
                            type="button"
                            @click="onDelete(item.id)"
                        >
                            {{ $t("roofSheathingsPanel.Delete") }}
                        </v-btn>
                    </div>

                    <v-text-field
                        v-model="item.price_per_module"
                        :label="$t('roofSheathingsPanel.Price per module')"
                        variant="outlined"
                        density="compact"
                        type="input"
                    />

                    <v-text-field
                        v-model="item.extra_price_per_installation"
                        :label="
                            $t(
                                'roofSheathingsPanel.Extra price per installation'
                            )
                        "
                        variant="outlined"
                        density="compact"
                        type="input"
                    />

                    <label class="form-label">
                        {{
                            $t(
                                "roofSheathingsPanel.Forces lightning protection"
                            )
                        }}

                        <input
                            type="checkbox"
                            class="ml-2 bg-gray-200"
                            :checked="item.forces_lightning_protection"
                            @change="onForcesLightningProtectionChange(index)"
                        />

                    </label>


                    <label class="form-label">Visible in Sales Calc
                        <input
                            type="checkbox"
                            class="ml-2 bg-gray-200"
                            :checked="item.visible_sales_calc"
                            @change="onVisibleInSalesCalcChange(index)"
                        />

                    </label>


                    <label class="form-label">Visible in LPs

                        <input
                            type="checkbox"
                            class="ml-2 bg-gray-200"
                            :checked="item.visible_lps"
                            @change="onVisibleInLpsChange(index)"
                        />
                    </label>
                </div>

                <div class="d-flex align-center mt-3">
                    <v-btn
                        color="primary"
                        variant="flat"
                        size="small"
                        type="submit"
                    >
                        {{ $t("roofSheathingsPanel.Update") }}
                    </v-btn>

                    <v-btn
                        color="secondary"
                        variant="flat"
                        size="small"
                        type="button"
                        class="ml-2"
                        @click="showNewItemModal = true"
                    >
                        {{ $t("roofSheathingsPanel.Add a new one") }}
                    </v-btn>
                </div>
            </form>

            <v-dialog
                v-model="showNewItemModal"
                max-width="700"
                persistent
                scrollable
            >
                <v-card>
                    <v-card-title class="text-subtitle-1">
                        {{ $t("roofSheathingsPanel.Add a new one") }}
                    </v-card-title>

                    <v-divider/>

                    <v-card-text style="max-height: 600px">
                        <v-text-field
                            v-model="newItemModalForm.name"
                            :label="$t('roofSheathingsPanel.Name')"
                            variant="outlined"
                            density="compact"
                            type="input"
                        />

                        <v-text-field
                            v-model="newItemModalForm.price_per_module"
                            :label="$t('roofSheathingsPanel.Price per module')"
                            variant="outlined"
                            density="compact"
                            type="input"
                        />

                        <v-text-field
                            v-model="
                                newItemModalForm.extra_price_per_installation
                            "
                            :label="
                                $t(
                                    'roofSheathingsPanel.Extra price per installation'
                                )
                            "
                            variant="outlined"
                            density="compact"
                            type="input"
                        />

                        <label class="form-label">
                            {{
                                $t(
                                    "roofSheathingsPanel.Forces lightning protection"
                                )
                            }}

                            <input
                                type="checkbox"
                                class="ml-2 bg-gray-200"
                                :checked="newItemModalForm.forces_lightning_protection"
                                @change="onModalForcesLightningProtectionChange()"
                            />
                        </label>
                        <label class="form-label"> Visible in Sales Calc

                            <input
                                type="checkbox"
                                class="ml-2 bg-gray-200"
                                :checked="newItemModalForm.visible_sales_calc"
                                @change="onModalVisibleInSalesCalcChange()"
                            />
                        </label>
                        <label class="form-label"> Visible in LPs

                            <input
                                type="checkbox"
                                class="ml-2 bg-gray-200"
                                :checked="newItemModalForm.visible_lps"
                                @change="onModalVisibleInLpsChange()"
                            />
                        </label>
                    </v-card-text>

                    <v-divider/>

                    <v-card-actions>
                        <v-spacer/>

                        <v-btn
                            variant="flat"
                            size="small"
                            @click="onNewItemModalCancel()"
                        >
                            {{ $t("roofSheathingsPanel.Cancel") }}
                        </v-btn>

                        <v-btn
                            color="secondary"
                            variant="flat"
                            size="small"
                            @click="onNewItemModalSave()"
                        >
                            {{ $t("roofSheathingsPanel.Save") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated";

export default {
    props: {
        roofSheathingsData: {
            type: Array,
            required: true,
        },
    },
    components: {
        AuthenticatedLayout,
    },
    data: () => ({
        showNewItemModal: false,
        newItemModalForm: {
            name: null,
            price_per_module: 0,
            extra_price_per_installation: 0,
            forces_lightning_protection: 0,
            visible_sales_calc: 0,
            visible_lps: 0,
        },
    }),
    methods: {
        onDelete(id) {
            if (
                !confirm(
                    this.$t(
                        "roofSheathingsPanel.Are you sure you want to delete this roof sheathing"
                    )
                )
            ) {
                return;
            }

            this.$inertia.delete(
                this.route("roof-sheathings-panel.delete", id)
            );
        },
        onForcesLightningProtectionChange(index) {
            this.roofSheathingsData[index].forces_lightning_protection =
                !this.roofSheathingsData[index].forces_lightning_protection;

            this.roofSheathingsData[index].forces_lightning_protection =
                +this.roofSheathingsData[index].forces_lightning_protection;
        },
        onVisibleInSalesCalcChange(index) {
            this.roofSheathingsData[index].visible_sales_calc =
                !this.roofSheathingsData[index].visible_sales_calc;
            this.roofSheathingsData[index].visible_sales_calc =
                +this.roofSheathingsData[index].visible_sales_calc;

        },
        onVisibleInLpsChange(index) {
            this.roofSheathingsData[index].visible_lps =
                !this.roofSheathingsData[index].visible_lps;
            this.roofSheathingsData[index].visible_lps =
                +this.roofSheathingsData[index].visible_lps;

        },
        onUpdate() {
            this.$inertia.patch(
                this.route("roof-sheathings-panel.update"),
                this.roofSheathingsData
            );
        },
        onModalForcesLightningProtectionChange() {
            this.newItemModalForm.forces_lightning_protection =
                !this.newItemModalForm.forces_lightning_protection;

            this.newItemModalForm.forces_lightning_protection =
                +this.newItemModalForm.forces_lightning_protection;
        },
        onModalVisibleInSalesCalcChange() {
            this.newItemModalForm.visible_sales_calc =
                !this.newItemModalForm.visible_sales_calc;

            this.newItemModalForm.visible_sales_calc =
                +this.newItemModalForm.visible_sales_calc;
        },
        onModalVisibleInLpsChange() {
            this.newItemModalForm.visible_lps =
                !this.newItemModalForm.visible_lps;

            this.newItemModalForm.visible_lps =
                +this.newItemModalForm.visible_lps;
        },
        onNewItemModalFormReset() {
            this.newItemModalForm = {
                name: null,
                price_per_module: 0,
                extra_price_per_installation: 0,
                forces_lightning_protection: 0,
                visible_sales_calc: 0,
                visible_lps: 0,
            };
        },
        onNewItemModalCancel() {
            this.showNewItemModal = false;

            this.onNewItemModalFormReset();
        },
        onNewItemModalSave() {
            this.$inertia.post(
                this.route("roof-sheathings-panel.store"),
                this.newItemModalForm
            );

            this.onNewItemModalCancel();
        },
    },
};
</script>
